import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "grid grid-cols-4 gap-4 p-4"
};
const _hoisted_2 = ["onClick"];
import { generateColorMap } from "@/modules/vue/utils";
import { app } from "@/di";
import { MenuNavigationComponentManager } from "@/modules/vue/services/MenuNavigationComponentManager";
import { ColorEnum } from "@/modules/vue/enums";
import Icon from "@/modules/vue/components/Icon.vue";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuNavigation',
  emits: ['update:modelValue'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const menuNavigationComponentManager = app.get(MenuNavigationComponentManager);
    const colorClassMap = generateColorMap({
      bg: 100,
      text: 700
    });
    const items = computed(() => menuNavigationComponentManager.getItems());
    const router = useRouter();
    const navigate = route => {
      hide();
      router.push(route);
    };
    const dialog = ref(null);
    const quitGame = async () => {
      await dialog.value?.confirm();
      router.push({
        name: 'main-menu.index'
      });
    };
    const actionSheet = ref(null);
    const show = () => actionSheet.value.show();
    const hide = () => actionSheet.value.hide();
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SimpleActionSheet, {
        ref_key: "actionSheet",
        ref: actionSheet,
        "hide-cancel": "",
        "no-scrollbar": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('navigation')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, i) => {
          return _openBlock(), _createElementBlock("div", {
            key: i,
            class: _normalizeClass(["flex flex-col items-center justify-center h-16 rounded text-4xl cursor-pointer", _unref(colorClassMap)[item.color]]),
            onClick: $event => navigate(item.route)
          }, [_createVNode(Icon, {
            icon: item.icon,
            size: "2.5rem"
          }, null, 8, ["icon"])], 10, _hoisted_2);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.times((4 - _unref(items).length % 4 + 1) % 4), i => {
          return _openBlock(), _createElementBlock("div");
        }), 256)), _createElementVNode("div", {
          class: "flex flex-col items-center justify-center h-16 bg-green-100 text-green-700 rounded text-4xl cursor-pointer",
          onClick: _cache[0] || (_cache[0] = $event => navigate({
            name: 'game-slots.update'
          }))
        }, [_createVNode(Icon, {
          icon: _ctx.IconEnum.Save16Regular,
          size: "2.5rem"
        }, null, 8, ["icon"])]), _createElementVNode("div", {
          class: "flex flex-col items-center justify-center h-16 bg-slate-100 text-slate-700 rounded text-4xl cursor-pointer",
          onClick: _cache[1] || (_cache[1] = $event => navigate({
            name: 'settings.index'
          }))
        }, [_createVNode(Icon, {
          icon: _ctx.IconEnum.IosCog,
          size: "2.5rem"
        }, null, 8, ["icon"])]), _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col items-center justify-center h-16 rounded text-4xl cursor-pointer", _unref(colorClassMap)[_unref(ColorEnum).Red]]),
          onClick: quitGame
        }, [_createVNode(Icon, {
          icon: _ctx.IconEnum.SignOut24Regular,
          size: "2.5rem"
        }, null, 8, ["icon"])], 2)]), _createVNode(RichDialog, {
          ref_key: "dialog",
          ref: dialog,
          "confirmation-only": _ctx.$t('not_saved_game_progress_will_be_lost')
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sure_you_want_to_quit?')), 1)]),
          _: 1
        }, 8, ["confirmation-only"])]),
        _: 1
      }, 512);
    };
  }
});